export function isFirefox() {
  return navigator.userAgent.indexOf("Firefox") >= 0;
}
